/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import ContentWrapper from './ContentWrapper';

class Content extends React.Component {
  render() {
    const { children } = this.props;
    return (
      <ContentWrapper {...this.props}>
        {children}
      </ContentWrapper>
    );
  }
}

export default Content;
